import React, { useContext } from "react";
import { AppContext } from "../../AppDataProvider/AppDataProvider";
import { GenericResourceData } from "./GenericResourceData/GenericResourceData";
import { ResourceData } from "./ResourceData/ResourceData";
export function ResourcesStep() {
  const {
    appData
  } = useContext(AppContext);
  const {
    isGenericBookingTool
  } = appData.bookingTool;
  return isGenericBookingTool ? <GenericResourceData /> : <ResourceData />;
}
export default ResourcesStep;